export default function () {

    $(function () {
        var sidebar = $('.sidebar');

        /*Add active class to nav-link based on url dynamically
        //Active class can be hard coded directly in html file also as required
        var current = location.pathname.split("/").slice(-1)[0].replace(/^\/|\/$/g, '');
        $('.nav li a', sidebar).each(function() {
            var $this = $(this);
            if (current === "") {
                //for root url
                if ($this.attr('href').indexOf("index.html") !== -1) {
                    $(this).parents('.nav-item').last().addClass('active');
                    if ($(this).parents('.sub-menu').length) {
                        $(this).closest('.collapse').addClass('show');
                        $(this).addClass('active');
                    }
                }
            } else {
                //for other url
                let partUrls = $this.attr('href').split('/');
                if (partUrls.includes(current)) {
                    $(this).parents('.nav-item').last().addClass('active');
                    if ($(this).parents('.sub-menu').length) {
                        $(this).closest('.collapse').addClass('show');
                        $(this).addClass('active');
                    }
                }
            }
        });*/

        // Close other submenu in sidebar on opening any
        sidebar.on('show.bs.collapse', '.collapse', function() {
            sidebar.find('.collapse.show').collapse('hide');
        });

        // Checkbox and radios
        $(".form-check label,.form-radio label").append('<i class="input-helper"></i>');

        // Select2
        const selects = $('.select2');
        selects.each(function (index, select) {
            $(select).select2({
                minimumResultsForSearch: 10,
                placeholder: 'Select data'
            }).on("select2:open", function () {
                $(".select2-search__field").attr("placeholder", "Search...");
            }).on("select2:close", function () {
                $(".select2-search__field").attr("placeholder", null);
            });
        });

        // Tooltip
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body'
        });

        // Popover
        $('[data-toggle="popover"]').popover();

        // initialize date picker
        function initDatepicker() {
            const dateFormat = 'DD MMMM YYYY';
            const fullDateFormat = 'DD MMMM YYYY';
            $('.datepicker:not([readonly])').each(function () {
                const options = {
                    singleDatePicker: true,
                    showDropdowns: true,
                    parentEl: $(this).closest('div') || 'body',
                    autoUpdateInput: false,
                    autoApply: true,
                    locale: {
                        format: dateFormat
                    },
                };
                if ($(this).data('min-date')) {
                    options.minDate = $(this).data('min-date');
                }
                if ($(this).data('max-date')) {
                    options.maxDate = $(this).data('max-date');
                }
                if ($(this).data('parent-el')) {
                    options.parentEl = $(this).data('parent-el');
                }
                if ($(this).data('locale-format')) {
                    options.locale.format = $(this).data('locale-format');
                }
                if ($(this).data('drops')) {
                    options.drops = $(this).data('drops');
                }
                $(this).daterangepicker(options)
                    .on("apply.daterangepicker", function (e, picker) {
                        picker.element.val(picker.startDate.format(picker.locale.format));

                        // update another picker element
                        const updateTarget = $(picker.element).data('update-target');
                        const updateMin = $(picker.element).data('update-min');
                        if (updateTarget) {
                            const pickedDate = moment(picker.startDate, picker.locale.format); // must be moment object
                            if (updateMin) {
                                if (Number(updateMin) > 0) {
                                    pickedDate.add(Number(updateMin || 0), 'd');
                                } else if (Number(updateMin) < 0) {
                                    pickedDate.subtract(Number(updateMin.toString().replace(/[^0-9]/g, "") || 0), 'd');
                                }
                            }
                            $(updateTarget).data('daterangepicker').minDate = pickedDate;

                            // set blank target if minimum date greater than current value
                            if (pickedDate.isAfter(moment($(updateTarget).val(), dateFormat))) {
                                $(updateTarget).val('').focus();
                            }
                        }
                    })
                    .on("hide.daterangepicker", function (e, picker) {
                        setTimeout(function () {
                            const formattedDate = $(picker.element).closest('.form-group').find('.formatted-date');
                            if (picker.element.val()) {
                                formattedDate.text(picker.startDate.format(fullDateFormat));
                            } else {
                                formattedDate.text('(Pick a date)');
                            }
                        }, 150);
                    })
                    .on('cancel.daterangepicker', function(ev, picker) {
                        $(this).val('')
                    });
            });
        }
        initDatepicker();
        window.initDatepicker = initDatepicker;
    });

};
